import React, {Suspense} from 'react';
import {Preloader} from '@ab/components';

const Main = React.lazy(() => import(/* webpackChunkName: "Quittance" */ './views/main.c'));

const Quittance = props => {
    return (
        <Suspense fallback={<Preloader className="center" />}>
            <Main {...props} />
        </Suspense>
    );
};

export default Quittance;
